export default __webpack_public_path__ + "static/media/type3.4b53b7f7.svg";